import { styled, StyledGrid } from '@raskrask-dk/rr-components'

export const StyledPaymentMethods = styled('div', {
    [`& ${StyledGrid}`]: {
        gridTemplateColumns: '1fr 1fr',
    },
})
